import classNames from "classnames";

import {TagSwatchProps} from "@/components/tagSwatch/TagSwatch.types.ts";

import styles from "./TagSwatch.module.scss";

export const TagSwatch = ({color, className, ...rest}: TagSwatchProps) => (
  <span {...rest} className={classNames(styles.swatch, className)} style={{backgroundColor: color}} />
);
